import { ATTRIBUTE_TYPE_MULTI_SELECT, ATTRIBUTE_TYPE_SINGLE_SELECT, ATTRIBUTE_TYPE_TEXT, handleValidateCodevalue, STATIC_ENTITY_CONFIG } from '../Utility/constant';
import { useSelector } from 'react-redux';
import { StyledGridContainer, StyledSubHeader } from './Styled';
import TextFiledWithLabel from './TextFieldWithLabel';
import AutoCompleteComponent from './AutoCompleteComponenet';
import { getFormattedAdditionalAttributeValue } from '../Utility/payloadFormatter';
import { useCallback, useMemo } from 'react';

const FIELD_COMPONENTS = {
  [ATTRIBUTE_TYPE_TEXT]: TextFiledWithLabel,
  [ATTRIBUTE_TYPE_SINGLE_SELECT]: AutoCompleteComponent,
  [ATTRIBUTE_TYPE_MULTI_SELECT]: AutoCompleteComponent,
};


const CustomizableFields = ({
  useWrapper = true,
  CUSTOMIZABLE_FIELDS = [],
    config = {},
    setValues,
  values = {},
  handleOnChange,
  isViewMode = false,
  errors = {},
  showHeader = true,
  entity,
}) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const handleSelectAutoComplete = useCallback(
      (event, value, fieldKey, componentType) => {
        let formattedValue;

        if (componentType === ATTRIBUTE_TYPE_MULTI_SELECT) {
          formattedValue = value?.map((item) => item?.name) || [];
        } else {
          formattedValue = value?.name || "";
        }

        setValues((prev) => ({
          ...prev,
          [fieldKey]: formattedValue,
        }));
      },
      [setValues]
    );
     
  const staticConfig = STATIC_ENTITY_CONFIG?.[entity] || {};
  // CHECK IF ANY FIELD IS VISIBLE
  const isAnyVisible = useMemo(
    () =>
      CUSTOMIZABLE_FIELDS.some(
        (field) => config?.[field]?.visibility
      ),
    [CUSTOMIZABLE_FIELDS, config]
  );

  if (!isAnyVisible) return null;

  const renderField = (fieldKey) => {
    const fieldConfig = config?.[fieldKey];
    // DO NOT RENDER IF NOT VISIBLE
    if (!fieldConfig?.visibility) return null;

    const fieldStaticConfig = staticConfig?.[fieldKey];

    // DEFAULT TYPE = text
    const componentType = fieldConfig?.type || ATTRIBUTE_TYPE_TEXT;
    const Component =
      FIELD_COMPONENTS?.[componentType] || TextFiledWithLabel;
    const isMultiple = componentType === ATTRIBUTE_TYPE_MULTI_SELECT
    const commonProps = {
      name: fieldKey,
      label: handleValidateCodevalue(
        internationalise,
        fieldStaticConfig?.label || ""
      ),
      limitTags : 1,
      value: handleValidateCodevalue(internationalise,getFormattedAdditionalAttributeValue({
      type: componentType,
      value: values?.[fieldKey],
      options: fieldConfig?.options || [],
      }),),
      required: fieldConfig?.mandatory || false,
      disabled: isViewMode,
      isLookup : true,
      error: isMultiple
        ? (!values?.[fieldKey]?.length && !!errors?.[fieldKey])
      : (!values?.[fieldKey] && !!errors?.[fieldKey]),
      optionSet: fieldConfig?.options || [],
      multiple: isMultiple || false,
      handleOnChange : handleOnChange,
      onChange: (event, value) =>
        componentType===ATTRIBUTE_TYPE_TEXT ? handleOnChange(event) :
      handleSelectAutoComplete(
        event,
        value,
        fieldKey,
        componentType
      ),
      };
    return <Component key={fieldKey} {...commonProps} />;
  };

  return (
    <>
      {showHeader && (
        <StyledSubHeader>
          {handleValidateCodevalue(
            internationalise,
            "COMMON_ADDITIONAL_ATTRIBUTES"
          )}
        </StyledSubHeader>
      )}
      {useWrapper ? (
        <StyledGridContainer>
          {CUSTOMIZABLE_FIELDS.map(renderField)}
        </StyledGridContainer>
        ) : (
        CUSTOMIZABLE_FIELDS.map(renderField)
      )}
    </>
  );
};

export default CustomizableFields;